import React from 'react';
import { FileText, AlertCircle, CheckSquare, Scale } from 'lucide-react';
import { useTheme } from '../context/ThemeContext'; // 👈 Theme Support Added

const TermsOfService = () => {
  const { isDark } = useTheme(); // 👈 Access Theme State

  const sections = [
    {
      icon: CheckSquare,
      title: 'Acceptance of Terms',
      content: 'By accessing or using the Odessey platform, you agree to be bound by these Terms of Service. If you disagree with any part of the terms, you may not access our services. We reserve the right to modify these terms at any time.'
    },
    {
      icon: FileText,
      title: 'Booking & Payments',
      content: 'All bookings made through Odessey are subject to availability and the specific terms and conditions of the respective travel providers (airlines, hotels, vehicle rentals). Odessey acts as an intermediary. Prices are subject to change until confirmed and fully paid. You are responsible for ensuring all traveler details are accurate at the time of booking.'
    },
    {
      icon: AlertCircle,
      title: 'Cancellations & Refunds',
      content: 'Cancellation policies vary strictly by the service provider. Odessey does not guarantee full refunds for canceled trips, flights, or accommodations. Our service fees and convenience charges are non-refundable. Please review the specific cancellation policy attached to your booking before confirming.'
    },
    {
      icon: Scale,
      title: 'User Conduct & Liability',
      content: 'You agree to use Odessey for lawful purposes only. You must not use our platform to make fraudulent or speculative bookings. Odessey shall not be liable for any direct, indirect, incidental, or consequential damages resulting from the use or inability to use our services, or from the actions of third-party travel providers.'
    }
  ];

  return (
    <div style={{ minHeight: '100vh', backgroundColor: isDark ? '#111827' : '#f9fafb', paddingBottom: '80px', fontFamily: 'system-ui, -apple-system, sans-serif', transition: 'background-color 0.3s', boxSizing: 'border-box' }}>
      
      {/* Hero Section */}
      <div style={{ backgroundColor: isDark ? '#030712' : '#111827', padding: '100px 16px 50px 16px', textAlign: 'center', position: 'relative', overflow: 'hidden', transition: 'background-color 0.3s' }}>
        <div style={{ position: 'absolute', inset: 0, backgroundImage: 'url(https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=1920&q=80)', backgroundSize: 'cover', backgroundPosition: 'center', opacity: 0.15 }} />
        <div style={{ position: 'relative', zIndex: 10, maxWidth: '800px', margin: '0 auto', boxSizing: 'border-box' }}>
          <h1 style={{ color: 'white', fontSize: 'clamp(32px, 5vw, 42px)', fontWeight: '900', marginBottom: '10px' }}>Terms of Service</h1>
          <p style={{ color: '#9ca3af', fontSize: '15px', lineHeight: '1.6' }}>Last updated: June 2026. Please read these terms carefully before using Odessey.</p>
        </div>
      </div>

      {/* Content Container */}
      <div style={{ maxWidth: '800px', margin: '-30px auto 0', padding: '0 16px', position: 'relative', zIndex: 20, boxSizing: 'border-box' }}>
        <div style={{ backgroundColor: isDark ? '#1f2937' : 'white', borderRadius: '20px', padding: '30px 20px', boxShadow: isDark ? '0 10px 30px rgba(0,0,0,0.5)' : '0 10px 30px rgba(0,0,0,0.05)', border: isDark ? '1px solid #374151' : '1px solid #e5e7eb', transition: 'background-color 0.3s, border-color 0.3s', boxSizing: 'border-box' }}>
          
          <p style={{ fontSize: '15px', color: isDark ? '#d1d5db' : '#4b5563', lineHeight: '1.7', marginBottom: '30px' }}>
            Welcome to Odessey. These Terms of Service govern your use of our website, mobile application, and all related services provided by Odessey Travel Platform. 
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '25px' }}>
            {sections.map((section, idx) => (
              <div key={idx} style={{ display: 'flex', gap: '15px', flexWrap: window.innerWidth < 480 ? 'wrap' : 'nowrap' }}>
                <div style={{ flexShrink: 0, width: '42px', height: '42px', backgroundColor: isDark ? '#082f49' : '#e0f2fe', borderRadius: '10px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: isDark ? '#38bdf8' : '#0284c7' }}>
                  <section.icon size={22} />
                </div>
                <div>
                  <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: isDark ? '#f9fafb' : '#111827', marginBottom: '6px' }}>{section.title}</h3>
                  <p style={{ fontSize: '14px', color: isDark ? '#d1d5db' : '#4b5563', lineHeight: '1.6', margin: 0 }}>{section.content}</p>
                </div>
              </div>
            ))}
          </div>

          <hr style={{ border: 'none', borderTop: isDark ? '1px solid #374151' : '1px solid #e5e7eb', margin: '30px 0' }} />

          <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: isDark ? '#f9fafb' : '#111827', marginBottom: '6px' }}>Changes to Services</h3>
          <p style={{ fontSize: '14px', color: isDark ? '#d1d5db' : '#4b5563', lineHeight: '1.6', margin: 0 }}>
            We reserve the right to withdraw or amend our service, and any service or material we provide via Odessey, in our sole discretion without notice. We will not be liable if for any reason all or any part of the platform is unavailable at any time or for any period.
          </p>

        </div>
      </div>
    </div>
  );
};

export default TermsOfService;